import React, {  } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { FormikHandlers, FormikErrors, FormikTouched } from 'formik';

import Card from '../../../components/Card';
import { distances } from '../../../styles/constants';
import { MarketingInput, DateTimePicker, DateTimePickersWrapper } from '../../common/components';
import { ValidationState } from '../../../components/Forms';
import { Campaign, Stage } from '../../types';
import { DiscountItem } from '../../../types/checkout';

interface CampaignBasicInfoProps {
    title: string;
    subtitle: string;
    values: Campaign;
    handleChange: FormikHandlers['handleChange'];
    handleBlur: FormikHandlers['handleBlur'];
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    errors: FormikErrors<Campaign>;
    touched: FormikTouched<Campaign>;
    isEdit?: boolean;
}

const CampaignBasicInfo = (
    {
        title,
        subtitle,
        values,
        handleChange,
        handleBlur,
        setFieldValue,
        errors,
        touched,
        isEdit,
    }: CampaignBasicInfoProps
) => {
    const { t } = useTranslation();

    // const visibleFromOptions = [0, 1, 2, 3, 4, 5, 6, 7].map((count) => ({
    //     label: t('marketing.campaign.days_before', { count }),
    //     value: `${count}`,
    // }));

    return (
        <Card title={title} subtitle={subtitle} shortHr marginBottom={distances.small}>
            <InputWrapper>
                <MarketingInput
                    type="text"
                    label={t('marketing.campaign.name')}
                    placeholder=""
                    name="name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    validation={
                        touched.name && errors.name
                            ? {
                                state: ValidationState.Invalid,
                                message: errors.name,
                            }
                            : undefined
                    }
                />
            </InputWrapper>
            <DateTimePickersWrapper>
                <DateTimePicker
                    value={{
                        date: values.dateFrom,
                        time: values.timeFrom,
                    }}
                    setDate={(dateFrom) => {
                        setFieldValue('dateFrom', dateFrom);
                    }}
                    setTime={(timeFrom) => {
                        setFieldValue('timeFrom', timeFrom);
                    }}
                    name={'dateTimePickerFrom'}
                    label={t('marketing.campaign.active_from')}
                    validation={
                        touched.dateFrom && errors.dateFrom
                            ? {
                                state: ValidationState.Invalid,
                                message: errors.dateFrom as string,
                            }
                            : undefined
                    }
                    isEdit={isEdit}
                />
                <DateTimePicker
                    value={{
                        date: values.dateTo,
                        time: values.timeTo,
                    }}
                    setDate={(dateTo) => {
                        setFieldValue('dateTo', dateTo);
                    }}
                    setTime={(timeTo) => {
                        setFieldValue('timeTo', timeTo);
                    }}
                    name={'dateTimePickerTo'}
                    label={t('marketing.campaign.active_to')}
                    validation={
                        touched.dateTo && errors.dateTo
                            ? {
                                state: ValidationState.Invalid,
                                message: errors.dateTo as string,
                            }
                            : undefined
                    }
                />
                <DropdownWrapper>
                    {/* <P>{t('marketing.campaign.visible_for')}</P>
                    <>
                        <MarketingDropdown
                            name='visibleFrom'
                            value={visibleFromOptions[values.visibleFrom]}
                            onChange={(option) => {
                                setFieldValue('visibleFrom', option.value);
                            }}
                            options={visibleForOptions}
                        />
                    </> */}
                </DropdownWrapper>
            </DateTimePickersWrapper>
        </Card>
    );
};

const InputWrapper = styled.div`
    width: 75%;
    margin-top: ${distances.normal};

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const DropdownWrapper = styled.div`
    flex: 1 1 200px;
`;

export default CampaignBasicInfo;
